export default __webpack_public_path__ + "static/media/desk.6c041bcf.avif";